var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Step"},[(_vm.mobile)?_c('VStack',{attrs:{"pstyle":_vm.reverse && { 'flex-direction': 'column-reverse' }}},[_vm._t("default")],2):_c('HStack',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }